import { useMemo } from 'react';

import { useAutoplayHiddenFlag } from '../../../store/compositeSelectors/useAutoplayHiddenFlag';
import { useConfigSlice } from '../../../store/slices/config/selectors';

export const useHelpChaptersToHideConnected = (): string[] => {
  const hideSubtitles = !useConfigSlice.isSubtitlesAvailable();
  const hideAutoplay = useAutoplayHiddenFlag();

  return useMemo(() => {
    const chaptersToHide = [];
    if (hideSubtitles) {
      chaptersToHide.push('subtitles');
    }
    if (hideAutoplay) {
      chaptersToHide.push('autoplay');
    }
    return chaptersToHide;
  }, [hideSubtitles, hideAutoplay]);
};
